import { Box, Container } from "@mui/material";
import BanderaContacto from "./components/BanderaContacto";
import CarruselContacto from "./components/CarruselContacto";
import FormularioContacto from "./components/FormularioContacto";

export default function Contacto() {
  return (
    <Box
      sx={{
        bgcolor: "#f8fafc",
      }}
    >
      <CarruselContacto />

      <Container
        maxWidth="lg"
        component="main"
        sx={{
          py: { xs: 4, md: 8 },
          px: { xs: 2, sm: 3, md: 4 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", md: "start" },
          gap: { xs: 4, md: "40px" },
        }}
      >
        <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 60%" }, width: "100%" }}>
          <FormularioContacto />
        </Box>

        <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 40%" }, width: "100%" }}>
          <BanderaContacto />
        </Box>
      </Container>
    </Box>
  );
}
